import { getCountries, getCountryCallingCode } from "libphonenumber-js";

export type CountryCodeOption = {
  code: string;
  country: string;
};

export const DEFAULT_COUNTRY_CODE = "+61";

type DisplayNamesCtor = new (
  locales?: string | string[],
  options?: { type: "region" },
) => {
  of(code: string): string | undefined;
};

type IntlWithDisplayNames = typeof Intl & {
  DisplayNames?: DisplayNamesCtor;
};

const resolveRegionName = (() => {
  const intlWithDisplayNames = Intl as IntlWithDisplayNames;
  if (!intlWithDisplayNames.DisplayNames) {
    return (code: string): string => code;
  }

  const displayNames = new intlWithDisplayNames.DisplayNames("en", {
    type: "region",
  });

  return (code: string): string => displayNames.of(code) || code;
})();

export const COUNTRY_CODE_OPTIONS: CountryCodeOption[] = getCountries()
  .map((countryCode) => ({
    code: `+${getCountryCallingCode(countryCode)}`,
    country: resolveRegionName(countryCode),
  }))
  .sort((a, b) => {
    if (a.country === b.country) {
      return a.code.localeCompare(b.code);
    }
    return a.country.localeCompare(b.country);
  });
